import { ScreenFlag } from "common/components/SerializedApp";
import type { RenderEnvironment } from "common/components/types";
import { supportsOfflineActionQueue } from "common/offline-action-queue";
import { useMemo } from "react";

import { useNetworkStatus } from "./use-network-status";

const flagsForEditComponentsAllowed = [ScreenFlag.IsAddItemScreen, ScreenFlag.IsFormScreen];

// Returns [editingAllowed, isOnline]
export function useEditComponentEnabledViaNetworkStatus(env: RenderEnvironment): [boolean, boolean] {
    const isOnline = useNetworkStatus();
    const worksOffline = useMemo(() => {
        const flags = env.screenFlags;
        return flagsForEditComponentsAllowed.some(f => flags?.has(f) === true);
    }, [env.screenFlags]);

    if (isOnline) return [true, true];
    if (!supportsOfflineActionQueue(env.appEnvironment.eminenceFlags)) return [false, false];
    return [worksOffline, false];
}
